import { AxiosError, AxiosResponse, default as axios } from 'axios';
import { Auth } from '@trustpilot/ecommscript-integrationappauth/external-authentication';
import { logError } from './ecommscriptClient';
import { TierFeatures } from '../Model';
import { Tools } from '../Tools';

const tiersapi = `${process.env.REACT_APP_B2bApiUrl}/v1/private/business-units/`;

export const getBusinessUnitTierFeatures = (businessUnitId: string): Promise<string[]> => {
    const headers = {
        'authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${tiersapi}${businessUnitId}/features`, { headers })
        .then((response: AxiosResponse<TierFeatures>) => {
            if (response.data && response.data.features) {
                return response.data.features;
            }
            return [];
        })
        .catch((err: AxiosError) => {
            logError({
                message: `Failed getting getBusinessUnitTierFeatures with BUID ${businessUnitId}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return [];
        });
};
